import {
    ARTICLE_SET_ACTIVE,
    ARTICLES_REQUEST,
    ARTICLES_RECEIVE,
    ARTICLES_REQUEST_FAILURE
} from '../../action-types';

const initialState = {
    isCreating: false,
    isFetching: false,
    items: [],
    activeArticle: false,
    errors: []
};

export default function articles( state = initialState, action ) {

    switch ( action.type ) {

        case ARTICLES_REQUEST:

            return Object.assign({}, state, {
                isFetching: true
            });

        case ARTICLES_RECEIVE:

            return Object.assign({}, state, {
                items: [ ...state.items, ...action.articles ]
            });

        case ARTICLES_REQUEST_FAILURE:

            return Object.assign({}, state, {
                isFetching: false,
                error: [ ...state.errors, ...action.error ]
            });

        case ARTICLE_SET_ACTIVE:

            return Object.assign({}, state, {
                isFetching: false,
                activeArticle: action.activeArticle
            });

        default:
            return state;

    }

}


/** WEBPACK FOOTER **
 ** ./src/state/reducers/articles/index.js
 **/